export default __webpack_public_path__ + "eee8078021b5ca1c43ab4367abca22cf.png";